import { PingRequest } from '../message/request/PingRequest';
import { PingResponse } from '../message/response/PingResponse';
var LatencyTracker = (function () {
    function LatencyTracker(cb, conn) {
        this.cb = cb;
        this.conn = conn;
        this.isRequestPending = false;
        this.request = new PingRequest();
    }
    LatencyTracker.prototype.start = function (interval) {
        var _this = this;
        if (this.timeout !== undefined) {
            throw new Error('LatencyTracker already running!');
        }
        this.conn.setMessageProcessor('Foundation::PingResponse', this.handlePingResponse.bind(this));
        this.timeout = setInterval(function () {
            if (!_this.conn.isAuthenticated()) {
                _this.cb(undefined, undefined, undefined, 'Skipping ping request, connection not authenticated!');
                return;
            }
            if (_this.isRequestPending) {
                if (Date.now() - _this.request.timeAtSender < LatencyTracker.MAX_RESPONSE_LATENCY_MS) {
                    _this.cb(_this.request.timeAtSender, undefined, undefined, 'Skipping ping request, previous request pending!');
                    return;
                }
                _this.cb(_this.request.timeAtSender, undefined, undefined, 'Clearing ping request, previous request exceeded timeout!');
            }
            _this.isRequestPending = true;
            _this.request.resetTimeAtSender();
            _this.conn.send(_this.request.getPtlMessage());
        }, interval);
        if (typeof window === 'undefined') {
            this.timeout.unref();
        }
    };
    LatencyTracker.prototype.stop = function () {
        clearInterval(this.timeout);
        this.timeout = undefined;
        this.isRequestPending = false;
        this.conn.setMessageProcessor('Foundation::PingResponse', undefined);
    };
    LatencyTracker.prototype.handlePingResponse = function (msg) {
        var resp = new PingResponse(msg);
        this.cb(resp.timeOfRequest, resp.latencyTotal, resp.latencyAtPeer, undefined);
        this.isRequestPending = false;
        return false;
    };
    LatencyTracker.MAX_RESPONSE_LATENCY_MS = 60 * 1000;
    return LatencyTracker;
}());
export { LatencyTracker };
//# sourceMappingURL=LatencyTracker.js.map